import React from 'react';
import {Alert, Box, Typography} from '@mui/material';
import {ActionType, CheckboxGroupField} from '../../components/AutoForm/AutoFieldNew';
import {ActionEnum} from '../../schema-types/globalTypes';
import {GetBulkAccounts_bulkAccounts_edges_node} from '../../schema-types/GetBulkAccounts';
import {BulkAdminValues} from './utils';
import {useRTQ} from '../../hooks/useRTQ';

export const useActionsField = (): CheckboxGroupField => {
  const {atrName} = useRTQ();
  return {
    type: ActionType.checkboxGroup,
    options: [
      {label: `Resend ${atrName} request`, value: ActionEnum.RESEND_ATR_REQUEST},
      {label: 'Resend fact find request', value: ActionEnum.RESEND_FACT_FIND_REQUEST},
      {
        label: 'Resend FPA signature request',
        value: ActionEnum.RESEND_FPA_SIGNATURE_REQUEST,
      },
    ],
    id: 'selectedActions',
    label: 'Please select the actions(s)',
  };
};

export const getIsATR = (values: BulkAdminValues) =>
  values.selectedActions.includes(ActionEnum.RESEND_ATR_REQUEST);
export const getisFactFind = (values: BulkAdminValues) =>
  values.selectedActions.includes(ActionEnum.RESEND_FACT_FIND_REQUEST);
export const getIsFPA = (values: BulkAdminValues) =>
  values.selectedActions.includes(ActionEnum.RESEND_FPA_SIGNATURE_REQUEST);

export function BulkAdminAlert({
  bulkAccounts,
  values,
}: {
  bulkAccounts: (GetBulkAccounts_bulkAccounts_edges_node | null | undefined)[];
  values: BulkAdminValues;
}) {
  const {atrName} = useRTQ();
  const isATR = getIsATR(values);
  const isFactFind = getisFactFind(values);
  const isFPA = getIsFPA(values);
  const invalidAccounts = bulkAccounts.filter((x) => {
    if (!x || !values.selectedIDs.includes(x.id)) {
      return false;
    }

    if (
      (!x.canRequestAtr?.isAllowed && isATR) ||
      (!x.canRequestCq?.isAllowed && isFactFind) ||
      (!x.canRequestFpa?.isAllowed && isFPA)
    ) {
      return true;
    }

    return false;
  });

  if (!invalidAccounts.length) {
    return null;
  }

  return (
    <Box mb={1} height="200px" overflow="auto">
      <Alert severity="warning">
        Please check why the actions below will not be sent:
        <ul>
          {invalidAccounts.map((x) => {
            return (
              <li key={x?.id}>
                {isATR && !x?.canRequestAtr?.isAllowed && (
                  <>
                    <Typography>{`${x?.accountName} cannot request ${atrName}. ${x?.canRequestAtr?.disallowedReason}`}</Typography>
                    <br />
                  </>
                )}
                {isFactFind && !x?.canRequestCq?.isAllowed && (
                  <>
                    <Typography>{`${x?.accountName} cannot request CQ. ${x?.canRequestCq?.disallowedReason}`}</Typography>
                    <br />
                  </>
                )}
                {isFPA && !x?.canRequestFpa?.isAllowed && (
                  <>
                    <Typography>{`${x?.accountName} cannot request FPA. ${x?.canRequestFpa?.disallowedReason}`}</Typography>
                    <br />
                  </>
                )}
              </li>
            );
          })}
        </ul>
      </Alert>
    </Box>
  );
}
